import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import {
  CreateMachineTagForDuplicationMutation,
  CreateMachineTagForDuplicationMutationVariables,
} from '../../../__generated__/queries-web';
import { GET_ARTICLE_QUERY } from '../../../apollo/queries/articles.web.graphql';

export const DUPLICATE_TO_TOPIC_MACHINE_TAG = 'topicassignmentto:id';

const CREATE_MACHINE_TAG_FOR_DUPLICATION = gql`
  mutation CreateMachineTagForDuplication($data: MachineTagCreationInput!) {
    createMachineTag(data: $data) {
      id
    }
  }
`;

export const useCreateMachineTag = () => {
  const [createMachineTag] = useMutation<
    CreateMachineTagForDuplicationMutation,
    CreateMachineTagForDuplicationMutationVariables
  >(CREATE_MACHINE_TAG_FOR_DUPLICATION, {
    refetchQueries: [GET_ARTICLE_QUERY],
  });

  return useCallback(
    (variables: CreateMachineTagForDuplicationMutationVariables) =>
      createMachineTag({ variables }),
    [createMachineTag],
  );
};
